var cilHeader = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M16,496H496V16H16ZM48,48H464V464H48Z' class='ci-primary'/><polygon fill='var(--ci-primary-color, currentColor)' points='288 144 320 144 320 240 192 240 192 144 224 144 224 112 96 112 96 144 128 144 128 368 96 368 96 400 224 400 224 368 192 368 192 272 320 272 320 368 288 368 288 400 416 400 416 368 384 368 384 144 416 144 416 112 288 112 288 144' class='ci-primary'/>"];

export { cilHeader };

